import * as React from "react";
import {WarningModal} from "../modals/WarningModal";

interface IProps {
    title: string;
    bodyTopParagraph: JSX.Element;
    showModal: boolean;
    onModalHide: () => void;
    id: string;
    localPhoneNumber: string;
    abroadPhoneNumber: string;
}

export class ClaimReportingPopup extends React.Component<IProps, {}> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <WarningModal isOpen={this.props.showModal}
                onModalHide={this.props.onModalHide}
                id={this.props.id}
                title={this.props.title}
                body={this.getPopupBody()}
            />
        )
    }

    private getPopupBody(): React.ReactNode {
        const localPhoneNumber: string = this.props.localPhoneNumber;
        const abroadPhoneNumber: string = this.props.abroadPhoneNumber;

        return (
            <>
                {this.props.bodyTopParagraph}
                <div className="text-center mt-4 mb-4">
                    <a href={`tel:+44 ${localPhoneNumber}`}
                        className="mb-4 no-underline font-weight-semi-bold"
                        id="claimsPagePhoneLink"
                        aria-label={`Phone number +44 ${localPhoneNumber}`}>
                            {localPhoneNumber}
                    </a>
                    <p className="mb-1">or</p>
                    <a href={`tel:+44 ${abroadPhoneNumber}`}
                        className="mb-4 no-underline font-weight-semi-bold"
                        id="claimsPagePhoneLinkAbroad"
                        aria-label={`Phone number +44 ${abroadPhoneNumber}`}>
                            (+44) {abroadPhoneNumber}
                    </a>
                </div>
                <p>Lines open <b>24 hours, 7 days a week. </b>
                    Calls may be recorded and/or monitored for training and audit purposes.
                </p>
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/claims/ClaimReportingPopup.tsx